import { createFileRoute } from '@tanstack/react-router'
import { TemplateEditPage } from '@/features/agent-templates/template-edit-page'

export const Route = createFileRoute(
  '/_authenticated/automation/templates/$templateId/edit'
)({
  component: TemplateEditPage,
})
